import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { ReactNode } from 'react'

interface GuardRouteProps {
  children: ReactNode
  requireAuth?: boolean
  allowedRoles?: string[]
  allowedEmails?: string[]
  redirectTo?: string
}

export const GuardRoute = ({
  children,
  requireAuth = true,
  allowedRoles,
  allowedEmails,
  redirectTo = '/login'
}: GuardRouteProps) => {
  const { isAuthenticated, userRole, authUser } = useAuth()

  // Check authentication
  if (requireAuth && !isAuthenticated) {
    return <Navigate to={redirectTo} replace />
  }

  // Check allowed emails (exception list - bypass role check)
  if (allowedEmails && allowedEmails.length > 0) {
    if (authUser?.email && allowedEmails.includes(authUser.email)) {
      return <>{children}</>
    }
  }

  // Check allowed roles (whitelist approach)
  if (allowedRoles && allowedRoles.length > 0) {
    if (!userRole || !allowedRoles.includes(userRole)) {
      return <Navigate to={redirectTo} replace />
    }
  }

  return <>{children}</>
}
